import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import './EnhancedDaySelector.css';

const EnhancedDaySelector = ({ value, onChange, disabled }) => {
  const days = [
    { label: 'Domingo', shortLabel: 'Dom', value: 0 },
    { label: 'Segunda', shortLabel: 'Seg', value: 1 },
    { label: 'Terça', shortLabel: 'Ter', value: 2 },
    { label: 'Quarta', shortLabel: 'Qua', value: 3 },
    { label: 'Quinta', shortLabel: 'Qui', value: 4 },
    { label: 'Sexta', shortLabel: 'Sex', value: 5 },
    { label: 'Sábado', shortLabel: 'Sáb', value: 6 },
  ];

  const handleDayToggle = (dayValue) => {
    if (disabled) return;
    
    const newValue = [...value];
    const index = newValue.indexOf(dayValue);
    
    if (index == -1) {
      newValue.push(dayValue);
    } else {
      newValue.splice(index, 1);
    }
    
    onChange(newValue);
  };

  return (
    <Box className="enhanced-day-selector">
      {days.map((day) => {
        const isSelected = value.includes(day.value);
        return (
          <Chip
            key={day.value}
            label={
              <Box className="day-chip-content">
                <Typography variant="body2" className="day-chip-label">
                  {day.label}
                </Typography>
              </Box>
            }
            onClick={() => handleDayToggle(day.value)}
            className={`day-chip ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            clickable={!disabled}
          />
        );
      })}
    </Box>
  );
};

export default EnhancedDaySelector;